import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageManager: React.FC = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Update HTML lang attribute when language changes
    document.documentElement.lang = i18n.language;
    
    // Update document title based on current language
    const titles = {
      en: 'Expanse Passport - NGO Client Management',
      es: 'Expanse Passport - Gestión de Clientes para ONGs'
    };
    
    document.title = titles[i18n.language as keyof typeof titles] || titles.en;
  }, [i18n.language]);

  return null; // This component doesn't render anything
};

export default LanguageManager; 